import React, { Component, Fragment } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { Topbar, Footer } from './components';

export default Page =>
  class extends Component {
    state = {
      visible: false,
    };

    componentDidMount() {
      this.setState({ visible: true });
    }

    render() {
      return (
        <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {this.state.visible && (
            <Fragment>
              <header id="topnav">
                <Topbar />
              </header>

              <div className="wrapper">
                <Page {...this.props} />
              </div>

              <Footer />
            </Fragment>
          )}
        </ReactCSSTransitionGroup>
      );
    }
  };
